import React, { useState, useEffect } from 'react';
import { FilterWidget, GridView, SimpleView, Widget, Table, FormSelect, FormInput, CompositeView } from '@digital/ui';
import {
  searchValues,
  RelatorioEncerramentoContratos,
  EncerramentoFilter,
  relatorioExportExcel,
} from './@app/../../../api/relatorioEncerramentoContratos';
import { getAllStatusEncerramentoOptions } from './@app/../../../api/status';
import { ColumnProps } from 'antd/lib/table';
import { ExcelButton, SearchButton } from '@app/components/FormButtons';
import { getAllFornecedoresOptions } from '@app/api/fornecedor';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { FormSelectFilter } from '@app/components/FormSelectFilter';

const RelatorioEncerramentoContratos = () => {
  const [items, setItems] = useState<RelatorioEncerramentoContratos[]>();
  const [getList, setGetList] = useState<boolean>(true);

  useEffect(() => {
    var obj = {} as EncerramentoFilter;
    handleFilter(obj);
  }, [getList]);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Contrato',
      dataIndex: 'numeroContrato',
      width: '10%',
    },
    {
      title: 'Código',
      dataIndex: 'codigo',
      width: '10%',
    },
    {
      title: 'CNPJ',
      dataIndex: 'cnpj',
      width: '10%',
    },
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      width: '20%',
    },
    {
      title: 'Objeto',
      dataIndex: 'objeto',
      width: '10%',
    },
    {
      title: 'Diretoria',
      dataIndex: 'diretoria',
      width: '10%',
    },
    {
      title: 'Área',
      dataIndex: 'area',
      width: '10%',
    },
    {
      title: 'Departamento',
      dataIndex: 'departamento',
      width: '10%',
    },
    {
      title: 'Início da Vigência',
      dataIndex: 'inicioVigencia',
      width: '10%',
    },
    {
      title: 'Término da Vigência',
      dataIndex: 'terminoVigencia',
      width: '10%',
    },
    {
      title: 'Status de Vigência',
      dataIndex: 'statusVigencia',
      width: '10%',
    },
    {
      title: 'Vigência Atual',
      dataIndex: 'vigenciaAtual',
      width: '10%',
    },
    {
      title: 'Status do Contrato',
      dataIndex: 'statusContrato',
      width: '10%',
    },
    {
      title: 'Observação',
      dataIndex: 'observacao',
      width: '10%',
    },
    {
      title: 'Dias Remanescentes',
      width: '10%',
      render(text, record, index) {
        return record.diasRemanescentes > 0 ? record.diasRemanescentes : "";
      },
    },
    {
      title: 'Status do Encerramento',
      dataIndex: 'statusEncerramento',
      width: '10%',
    },
    {
      title: 'Nada Consta',
      dataIndex: 'nadaConsta',
      width: '10%',
    },
    {
      title: 'TEQC Assinado',
      dataIndex: 'teqcAssinado',
      width: '10%',
    },
    {
      title: 'Encerramento TOTVS',
      dataIndex: 'encerramentoTotvs',
      width: '20%',
    }
  ];

  const handleFilter = (values: EncerramentoFilter) => {
    searchValues(values).then(resp => resp && setItems(resp));
  };

  const handleExcel = async (values: EncerramentoFilter) => {
    relatorioExportExcel(values);
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView onSubmit={handleFilter}>
          <FilterWidget
            active={[]}
            actions={[
              <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
              <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />,
            ]}
            title="Filtros">
            <FormInput label="Contrato" name="numeroContrato" span={4} />
            <FormSelectFilter
              label="Fornecedor"
              name="fornecedoresId"
              span={4}
              dataOptions={() => getAllFornecedoresOptions()}
            />
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .startsWith(input.toLowerCase());
              }}
              mode="multiple"
              label="Status do Processo"
              getOptions={getAllStatusEncerramentoOptions}
              name="status"
              span={4}
            />
          </FilterWidget>
          <Widget title="Relatório de Encerramento de Contratos">
            <PerfectScrollbar>
              <Table columns={columns} dataSource={items || []} pagination={{ pageSize: 100 }} />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default RelatorioEncerramentoContratos;
